var url = "https://website-api.socialelite.io/api/contact-us";

window.getFormObj = function (form) {
    var formObj = {};
    var inputs = $(form).serializeArray();
    $.each(inputs, function (i, input) {
        if (formObj.hasOwnProperty(input.name)) {
            formObj[input.name] += ',' + input.value;
        } else {
            formObj[input.name] = input.value;
        }
        
    });
    return formObj;
}

window.onloadCallback = function() {
    $('.g-recaptcha').each(function(i, v) {
      const $placeholder = $(this)

      // Define a widget id that will be used by every grecaptcha method 
      // to keep track of which form is being used
      $placeholder.data('widget-id', i)

      grecaptcha.render( this, {
        callback: function( token ) {

          return new Promise(function(resolve, reject) {
            if( grecaptcha === undefined ) {
              console.log( 'reCaptcha not defined' )
              reject()
            }

            var response = grecaptcha.getResponse( $placeholder.data('widget-id') )
            if( !response ) {
              console.log( 'Could not get reCaptcha response' )
              reject()
            }

            const $form = $placeholder.closest('form')

            $form.find('.g-recaptcha-response').val( token )
            $form
            // Add a class that will be used to bypass the prevented submit event
            .addClass('recap-done')
            // submit by clicking the submit button of your form
            .find('[type="submit"]').trigger('click')
            resolve()
            // grecaptcha.reset( $placeholder.data('widget-id') )
          })
        },
        sitekey: "6LdyDsonAAAAAFOerLnKEwsPQTp3xIak4JMrOQH5",
        size: 'invisible', // This makes the real reCaptcha V2 Invisible
      })
    })
  }

  $('form').on('submit', function(e) {
    const $form = $(this)

    // 2nd pass (when the submit is triggered within the callback)
    // This bypasses the event to be prevented a new time -> form is really submitted
    if( $form.hasClass('recap-done') ) {
    //   return
        e.preventDefault();
        
        var token = $form.find('.g-recaptcha-response').val();

        var formResponse = $form.find('.form-response');

        const data = getFormObj($form);
        $.ajax({
            type: "POST",
            url: url,
            // The key needs to match your method's input parameter (case-sensitive).
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function(data){
                if (data.success) {
                    $(formResponse).removeClass('red').addClass('main-color').text("Cảm ơn Quý Khách đã quan tâm. Chúng tôi sẽ liên hệ Quý Khách trong thời gian sớm nhất!");
                } else {
                    $(formResponse).removeClass('main-color').addClass('red').text(data.message);
                }
            },
            error: function(errMsg) {
                $(formResponse).removeClass('main-color').addClass('red').text("Có lỗi trong quá trình xử lý. Xin Quý Khách vui lòng thử lại!");
                // grecaptcha.reset();
                grecaptcha.reset( $placeholder.data('widget-id') )
            }
        });
    }

    // 1st pass: prevents the form to be submitted and do the reCaptcha process
    const $placeholder = $form.find('.g-recaptcha');
    if( $placeholder.length > 0 ) {
      e.preventDefault()

      grecaptcha.execute( $placeholder.data('widget-id') )
    }
  })